module.exports = "/build/web/svg/social/small/facebook-blue.2150c13f4492c95e815577efe0371f66.svg";


//////////////////
// WEBPACK FOOTER
// ./svg/social/small/facebook-blue.svg
// module id = 112
// module chunks = 24